import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  failed = false;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    private afs: AngularFirestore,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
  }

  deleteCategory(): void {
    this.afs.collection('categories').ref.where('uniqueName', '==', this.data.key).get().then(isDelete => {
      this.afs.collection('categories').doc(isDelete.docs[0].id).delete();
    }).then(() => {
      this.afs.collection('entities').ref.where('uniqueName', '==', this.data.key).get().then((categoryDelete) => {
        if (!categoryDelete.empty) {
          this.afs.collection('entities').doc(categoryDelete.docs[0].id).delete();
        }


      })
    });
    this.dialogRef.close();

  }

  close() {
    this.dialogRef.close();
  }


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/category-list/dialog/dialog.component.ts